
export default {
  // Hero Section
  'hero.slide1.title': 'البيوت المحمية الذكية لمستقبل أخضر',
  'hero.slide1.subtitle': 'التكنولوجيا الهولندية، الجودة الإيرانية',
  'hero.slide1.description': 'مع أكثر من 15 عامًا من الخبرة، رائدون في بناء البيوت المحمية الحديثة والمعدات الزراعية المتقدمة',
  'hero.slide2.title': 'التكنولوجيا الزراعية المتقدمة',
  'hero.slide2.subtitle': 'أنظمة الري الذكية ومراقبة المناخ',
  'hero.slide2.description': 'تقديم أشمل الحلول التكنولوجية لزيادة الإنتاجية وجودة المنتجات الزراعية',
  'hero.slide3.title': 'الشريك الموثوق للمزارعين الإيرانيين',
  'hero.slide3.subtitle': 'أكثر من 50 مشروعًا ناجحًا في جميع أنحاء البلاد',
  'hero.slide3.description': 'من التصميم إلى التنفيذ والدعم، نرافقكم في طريق تطوير الزراعة الحديثة والمستدامة',
  
  // Buttons
  'buttons.view_products': 'عرض المنتجات',
  'buttons.request_consultation': 'طلب استشارة',
  'buttons.view_projects': 'المشاريع',
  
  // Stats Section
  'stats.projects': 'مشروع ناجح',
  'stats.area': 'متر مربع مبني',
  'stats.experience': 'سنة خبرة',
  'stats.customers': 'عميل راضٍ',
  
  // Services Section
  'services.title': 'خدماتنا',
  'services.description': 'تقديم أشمل الخدمات في تصميم وبناء وصيانة البيوت المحمية الحديثة',
  'services.design.title': 'تصميم وبناء البيوت المحمية',
  'services.design.description': 'تصميم وبناء البيوت المحمية الحديثة بتكنولوجيا عالمية ومعايير دولية',
  'services.smart.title': 'الأنظمة الذكية',
  'services.smart.description': 'تركيب وتشغيل أنظمة مراقبة المناخ والري والمراقبة الذكية',
  'services.consulting.title': 'الاستشارة المهنية',
  'services.consulting.description': 'تقديم الاستشارات المهنية في الزراعة الحديثة وتحسين الإنتاج',
  'services.maintenance.title': 'الصيانة والدعم',
  'services.maintenance.description': 'خدمات الصيانة والإصلاح والدعم على مدار 24 ساعة لجميع المعدات',
  
  // About Section
  'about.title': 'حول Iran GH',
  'about.description1': 'رائدون في بناء البيوت المحمية الحديثة وتقديم الحلول الزراعية المبتكرة',
  'about.why_us.title': 'لماذا Iran GH؟',
  'about.why_us.experience': 'أكثر من 15 عامًا من الخبرة الناجحة',
  'about.why_us.quality': 'جودة مضمونة للمنتجات',
  'about.why_us.support': 'دعم الخبراء 24/7',
  'about.why_us.projects': 'أكثر من 50 مشروعًا ناجحًا',
  'about.why_us.description': 'بناءً على الخبرة والمعرفة التقنية، نوفر أفضل الحلول للبيوت المحمية لكم.',
  'about.expertise.title': 'خبرتنا',
  'about.expertise.smart_design': 'تصميم البيوت المحمية الذكية',
  'about.expertise.climate_control': 'أنظمة مراقبة المناخ',
  'about.expertise.irrigation': 'معدات الري المتقدمة',
  'about.expertise.consulting': 'الاستشارة الزراعية المهنية',
  'about.expertise.description': 'فريق خبرائنا يقدم حلولاً مبتكرة باستخدام أحدث التقنيات.',
  'about.partnership.title': 'الشراكة الدولية',
  'about.partnership.dutch_tech': 'التكنولوجيا الهولندية المتقدمة',
  'about.partnership.vander_hoeven': 'الشراكة مع Vander Hoeven',
  'about.partnership.european_standards': 'المعايير الأوروبية',
  'about.partnership.global_quality': 'ضمان الجودة العالمية',
  'about.partnership.description': 'من خلال الشراكات الدولية، نوفر لكم أفضل التقنيات في العالم.',
  'about.cta.title': 'مستعدون للعمل معكم',
  'about.cta.description': 'من الاستشارة المجانية إلى التنفيذ الكامل للمشروع، سنكون معكم في جميع المراحل',
  'about.cta.learn_more': 'تعرفوا علينا أكثر',
  'about.cta.contact': 'اتصلوا بنا',
  
  // Partners Section
  'partners.title': 'شركاؤنا',
  'partners.description': 'التعاون مع أعرق الشركات المحلية والأجنبية في تكنولوجيا البيوت المحمية',
  'partners.international': 'الشراكات الدولية',
  'partners.vander.name': 'Vander Hoeven',
  'partners.vander.country': 'الشريك الهولندي الرسمي',
  'partners.vander.years': '10+ سنوات من التعاون',
  'partners.vander.tech': 'التكنولوجيا الهولندية المتقدمة',
  'partners.vander.description': 'الشريك الهولندي الرسمي مع أكثر من 10 سنوات من التعاون الناجح',
  'partners.chehelsotoon.name': 'Chehelsotoon',
  'partners.chehelsotoon.country': 'الشريك التجاري المحلي',
  'partners.chehelsotoon.years': '8+ سنوات من التعاون',
  'partners.chehelsotoon.quality': 'الإنتاج المحلي عالي الجودة',
  'partners.chehelsotoon.description': 'الشريك التجاري المحلي مع الإنتاج المحلي عالي الجودة',
  'partners.benefits.title': 'مزايا شراكاتنا',
  'partners.benefits.description': 'لماذا الشراكة معنا هي الخيار الصحيح؟',
  'partners.benefits.global_access': 'الوصول العالمي',
  'partners.benefits.global_desc': 'الاتصال بالأسواق الدولية',
  'partners.benefits.advanced_tech': 'التكنولوجيا المتقدمة',
  'partners.benefits.tech_desc': 'أحدث التقنيات العالمية',
  'partners.benefits.quality_guarantee': 'ضمان الجودة',
  'partners.benefits.quality_desc': 'معايير الجودة الدولية',
  'partners.benefits.support': 'الدعم 24/7',
  'partners.benefits.support_desc': 'خدمات ما بعد البيع المهنية',
  'partners.cta': 'كونوا شركاءنا',
  
  // Testimonials Section
  'testimonials.title': 'آراء العملاء',
  'testimonials.description': 'ما يقوله عملاؤنا حول جودة خدماتنا ومنتجاتنا',
  'testimonials.customer1.name': 'أحمد محمدي',
  'testimonials.customer1.position': 'مدير المجمع الزراعي في أصفهان',
  'testimonials.customer1.text': 'جودة البناء ومعدات Iran GH ممتازة. تم بناء بيتنا المحمي بأفضل التقنيات.',
  'testimonials.customer2.name': 'فاطمة كريمي',
  'testimonials.customer2.position': 'خبيرة زراعية في مشهد',
  'testimonials.customer2.text': 'التعاون مع Iran GH كان تجربة ممتازة. تم كل شيء بمهنية من التصميم إلى التنفيذ.',
  'testimonials.customer3.name': 'رضا أحمدي',
  'testimonials.customer3.position': 'مالك بيت محمي في أردبيل',
  'testimonials.customer3.text': 'التكنولوجيا الهولندية والخدمات الإيرانية، مزيج ممتاز أدى إلى نجاح أعمالنا.',
  
  // CTA Section
  'cta.title': 'مستعدون لبدء مشروعكم القادم؟',
  'cta.description': 'اتصلوا بفريق خبرائنا واحصلوا على استشارة مجانية',
  'cta.phone': '+98 21 8844 1386',
  
  // Navigation
  'nav.read_more': 'اقرأ المزيد',
  'nav.view_services': 'عرض الخدمات',
  'nav.view_partners': 'عرض الشركاء',
  'nav.cooperation_level': 'مستوى التعاون',
  
  // Story Section
  story: {
    badge: 'تاريخ شركة آريا جرين هاوس',
    title: 'قصة نجاح آريا جرين هاوس',
    subtitle: 'شركة آريا جرين هاوس، مع أكثر من 15 عامًا من الخبرة في تصميم وبناء وتجهيز البيوت المحمية الحديثة، رائدة في صناعة البيوت المحمية في إيران ومنطقة الشرق الأوسط.',
    
    founding: {
      title: 'تأسيس آريا جرين هاوس',
      description: 'تأسست آريا جرين هاوس في عام 2009 بهدف تقديم حلول مبتكرة في صناعة البيوت المحمية. تطورت شركتنا من وحدة هندسية صغيرة إلى أكبر مزود لمعدات البيوت المحمية في البلاد.'
    },
    
    growth: {
      title: 'نمو وتطوير آريا جرين هاوس',
      description: 'خلال سنوات عملنا، أكملت آريا جرين هاوس بنجاح أكثر من 200 مشروع في جميع أنحاء البلاد والمنطقة. من البيوت المحمية العائلية الصغيرة إلى المجمعات التجارية الكبيرة، كلها تقع ضمن مجال خبرتنا.'
    },
    
    achievements: {
      title: 'إنجازات آريا جرين هاوس',
      description: 'اليوم، تُعرف آريا جرين هاوس كرائدة في تقنيات البيوت المحمية الذكية وتساعد المزارعين على تحقيق عوائد أعلى من خلال الاستخدام الأمثل للموارد.'
    },
    
    image_alt: 'تاريخ وإنجازات شركة آريا جرين هاوس',
    
    highlight: {
      title: 'آريا جرين هاوس - رائدة في الابتكار',
      description: 'مع أكثر من 150,000 متر مربع من البيوت المحمية المبنية و100+ عميل راضٍ'
    },
    
    timeline: {
      title: 'مسار تقدم آريا جرين هاوس',
      2009: {
        title: 'بداية العمليات',
        description: 'تأسيس آريا جرين هاوس مع فريق متخصص وملتزم'
      },
      2015: {
        title: 'توسيع الخدمات',
        description: 'تقديم خدمات التصميم والبناء للبيوت المحمية الذكية'
      },
      2020: {
        title: 'قيادة السوق',
        description: 'أصبحت رائدة في صناعة البيوت المحمية في إيران'
      },
      2024: {
        title: 'الابتكار المستمر',
        description: 'إدخال تقنيات إنترنت الأشياء والذكاء الاصطناعي المتقدمة'
      }
    },
    
    milestones: {
      projects: {
        title: 'المشاريع الناجحة لآريا جرين هاوس',
        subtitle: 'أكثر من 200 مشروع مكتمل',
        description: 'اكتسبت آريا جرين هاوس خبرة غنية وخبرة عالية من خلال التنفيذ الناجح لمشاريع متنوعة، من البيوت المحمية العائلية الصغيرة إلى المجمعات التجارية الكبيرة.',
        item1: 'البيوت المحمية المائية المتقدمة',
        item2: 'أنظمة التحكم في المناخ الذكية',
        item3: 'معدات الري الأوتوماتيكية'
      },
      expansion: {
        title: 'التوسع الإقليمي لآريا جرين هاوس',
        subtitle: 'الحضور في الشرق الأوسط',
        description: 'وسعت آريا جرين هاوس أنشطتها إلى البلدان المجاورة وتُعرف كمرجع متخصص في منطقة الشرق الأوسط.',
        item1: 'تصدير المعدات إلى البلدان المجاورة',
        item2: 'الاستشارات الفنية والتصميم الدولي',
        item3: 'الشراكة مع الشركات الإقليمية المرموقة'
      }
    },
    
    innovation: {
      title: 'الابتكار في آريا جرين هاوس',
      subtitle: 'آريا جرين هاوس دائمًا في المقدمة من التقنيات الجديدة وتقدم حلولاً متقدمة من خلال البحث والتطوير المستمر.',
      research: {
        title: 'البحث والتطوير',
        description: 'الاستثمار المستمر في البحث العلمي وتطوير تقنيات البيوت المحمية الجديدة'
      },
      technology: {
        title: 'التكنولوجيا الذكية',
        description: 'تنفيذ أنظمة إنترنت الأشياء والذكاء الاصطناعي والأتمتة المتقدمة'
      },
      sustainability: {
        title: 'الاستدامة البيئية',
        description: 'التركيز على الحلول الصديقة للبيئة والاستهلاك الأمثل للموارد'
      }
    }
  }
};
